import React from 'react';
import cx from 'classnames';
import cs from './index.module.scss';
import eyeShowIcon from '@/assets/img/login/eye-show.png';

const EyeShowIcon: React.FC<any> = ({ className, ...restProps }) => (
  <span className={cx(cs.container, className)} {...restProps}>
    <img src={eyeShowIcon} alt="" width={20} height={20} />
  </span>
);

export default EyeShowIcon;
